import '@ssml-editor/core';
import { MenuBaseService, EditorUtils } from '@ssml-editor/vue';
import { Alphabet } from '../../module/phoneme/alphabet.enum.js';
import { PHONEME_TYPE } from '../../module/phoneme/constant.js';
import { SAY_AS_TYPE } from '../../module/say-as/constant.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import { SOUND_EVENT_TYPE } from '../../module/sound-event/constant.js';
import '@ssml-editor/modules';
import { SPEAK_TYPE } from '../../module/speak/constant.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { R as Range } from '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/index-B_A1dZu-.js';
import { SUB_TYPE } from '../../module/sub/constant.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import { Warning } from '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import '../say-as/constant.js';
/* empty css                        */
import '@element-plus/icons-vue';
/* empty css                        */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                       */
/* empty css                         */
/* empty css                     */
/* empty css                                  */
/* empty css                             */
/* empty css                         */
import '../voice/voice-menu.vue.js';

class SoundEventMenuService extends MenuBaseService {
  isDisabled() {
    if (super.isDisabled()) return true;
    const { selection } = this.editor;
    if (!selection) return true;
    if (Range.isExpanded(selection)) {
      throw new Warning("请不要框选文本");
    }
    const speakNode = EditorUtils.findSelectedNodeByType(
      this.editor,
      SPEAK_TYPE
    );
    if (!speakNode) {
      throw new Warning("请先为段落添加属性");
    }
    const subNode = EditorUtils.findSelectedNodeByType(this.editor, SUB_TYPE);
    if (subNode) {
      throw new Warning("无法插入到已添加别名的文本中");
    }
    const sayAsNode = EditorUtils.findSelectedNodeByType(
      this.editor,
      SAY_AS_TYPE
    );
    if (sayAsNode) {
      throw new Warning("无法插入到已添加读法的文本中");
    }
    const phonemeNode = EditorUtils.findSelectedNodeByType(
      this.editor,
      PHONEME_TYPE
    );
    if (phonemeNode) {
      const alphabet = phonemeNode.alphabet;
      if (alphabet === Alphabet.PY) {
        throw new Warning("无法插入到已添加拼音的文本中");
      } else {
        throw new Warning("无法插入到已添加音标的文本中");
      }
    }
    return false;
  }
  setNode(src, mark = "Sound") {
    if (!this.isDisabled()) {
      const node = {
        type: SOUND_EVENT_TYPE,
        src,
        mark,
        children: [{ text: "" }]
      };
      this.editor.insertNode(node);
    }
  }
}

export { SoundEventMenuService };
//# sourceMappingURL=sound-event-menu-service.js.map
